import { Stack, StackProps, styled } from '@mui/material';
import { generateClasses } from '../../utils/helper';

export const authClasses = generateClasses('Auth', ['content', 'authScreens']);

export const Root = styled((props: StackProps) => (
  <Stack flexDirection="row" width="100%" height="100%" {...props} />
))(({ theme }) => ({
  color: theme.palette.common.white,
  position: 'relative',

  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    backgroundImage: `url(${require('../../../../assets/background-waves.png')})`,
    backgroundPosition: 'top 0 left 0',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    pointerEvents: 'none',
  },

  [`& .${authClasses.content}`]: {
    flex: 65,
  },
  [`& .${authClasses.authScreens}`]: {
    flex: 35,
  },
}));

export const Content = styled((props: StackProps) => <Stack {...props} />)(({ theme }) => ({
  background: `linear-gradient(0deg, ${theme.palette.grey[900]} 0%, ${theme.palette.primary[900]} 100%)`,
}));
